// バックエンドの SchoolOrderChangeRequest::MAX_CHANGE_NUM と対で管理する
export const MAX_CHANGE_NUM = 10;
